import React, { Component } from 'react';
import MainMenu from '../../components/menu/MainMenu';
import { Redirect } from 'react-router-dom'
import { Card, Button } from 'react-bootstrap';
import moment from 'moment';
import SimpleModal from "../../components/modal/SimpleModal";
import LoadingModal from "../../components/modal/LoadingModal";
import './OnlineRegistrationReport.css';
import { getRegistrationReport, getExportRegistrationReport } from '../../resources/API';
import OnlineRegistrationReportTable from './components/OnlineRegistrationReportTable';
import { exportFileType, DEFAULT_DATE_EXPORT_RANGE } from '../../resources/Utils';

const defaultFilterCriteria = {
    merchantId: "",
    merchantName: "",
    merchantCustNo: "",
    fromDate: moment().subtract(DEFAULT_DATE_EXPORT_RANGE, "days").startOf('day').format('YYYYMMDDHHmmss'),
    toDate: moment().endOf("day").format('YYYYMMDDHHmmss'),
    payerAccount: "",
    statusCode: "",
    customerAcctCurrency: "",
    tableFilter: {
        page : 1,
        sizePerPage : 25,
        sortOrder : "desc",
        sortField : "dummy"
    }
};

class OnlineRegistrationReport extends Component {

    constructor(props) {
        super();
        defaultFilterCriteria.merchantId = props.merchantProfile.merchantId;
        const filterCriteria = props.location.state ?
                                props.location.state.filterCriteria :
                                {...defaultFilterCriteria};

        this.state = {
            reportList: [],
            reportCount: 0,
            merchantList: [],
            availableRefundAmountList: [],
            mode : props.match.params.mode,
            filterCriteria: {...filterCriteria},
            modal: {
                header: null,
                body: null,
                footer: null,
                show: false,
                variant: 'danger'
            },
            searchedCriteria: {...filterCriteria},
            loadingShow: false
        }
    }

    handleTableChange = (type, props) => {
        const {mode, searchedCriteria} = this.state;
        const tableChangeCriteria = {...searchedCriteria,
                                        tableFilter: {
                                            page : props.page,
                                            sizePerPage : props.sizePerPage,
                                            sortOrder : props.sortOrder,
                                            sortField : props.sortField
                                        }
                                    };
        this.getData(mode, tableChangeCriteria);
        this.setState({
            searchedCriteria: {...tableChangeCriteria}
        });
    }

    handleModalClose = () => {
        let modal = this.state.modal;
        this.setState({ modal: { ...modal, show: false } })
    }

    handleFilterCriteriaSubmit = () => {
        const { filterCriteria } = this.state;
        this.getData(this.state.mode, filterCriteria);
        this.setState({
            searchedCriteria: {...filterCriteria}
        });
    }

    handleRefresh = () => {
        this.getData(this.state.mode, this.state.searchedCriteria);
    }

    handleFilterCriteriaReset = () => {
        this.setState({
            filterCriteria: {...defaultFilterCriteria}
        });
    }

    handleExport = () => {
        const { filterCriteria } = this.state;
        if (filterCriteria.merchantId.trim() === "") {
            const footer = <React.Fragment>
                            <Button 
                                variant="scb" 
                                onClick={() => 
                                {
                                    this.handleModalClose();
                                    this.handleGenerateCSV();
                                }
                                }>Confirm</Button>
                            <Button variant="outline-secondary" onClick={this.handleModalClose}>Cancel</Button>
                        </React.Fragment>
            this.setState({
            modal : {
            header : "Export a large file",
            body : "You are exporting the report without specific merchant. This action might take long time. Are you sure to continue?",
            footer : footer,
            show : true,
            variant : "scb",
            backdrop : 'static'
            }
            });
        } else {
            this.handleGenerateCSV();
        }
    }

    handleGenerateCSV = async () => {
        const {downloading} = this.props;
        downloading.set(true);
        const res = await getExportRegistrationReport("ONLINE", this.state.filterCriteria, this.props.accessToken);
        downloading.set(false);
    }

    handleFilterCriteriaChange = (e) => {
        let { name, value } = e.target;

        let currentState = this.state.filterCriteria;
        currentState[name] = value;

        this.setState({
            filterCriteria: currentState
        });
    }

    async getData(mode, criteria) {
        this.setState({ loadingShow: true });
        const { accessToken } = this.props;

        let reportList = [];
        let reportCount = 0;

        const reportListResponse = await getRegistrationReport("ONLINE", criteria, accessToken);
        if (reportListResponse.status === 200) {
            reportList = reportListResponse.body.registrations.values;
            reportCount = reportListResponse.body.registrations.rowNum;
        }

        this.setState({
            reportList: reportList,
            reportCount: reportCount,
            searchedCriteria: {...criteria},
            loadingShow: false
        });
    }

    render() {
        const {
            reportList, reportCount, filterCriteria, searchedCriteria, modal, loadingShow
        } = this.state;
        const {role, accessToken, username, downloading} = this.props;
        
        if (!role.includes("DD_REPORT_ONLINE_REGISTRATION")) {
            return <Redirect to='/unauthorized' />
        }

        return (
            <React.Fragment>
                <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                    <Card.Body className="p-0 bg-grey">
                        <MainMenu mainMenu={"reports"} subMenu={"onlineRegistration"} role={role}/>
                        <OnlineRegistrationReportTable
                            reportList={reportList}
                            reportCount={reportCount}
                            // merchantList={merchantList}
                            // mode={mode}
                            filterCriteria={filterCriteria}
                            searchedCriteria={searchedCriteria}
                            role={role}
                            onFilterCriteriaSubmit={this.handleFilterCriteriaSubmit}
                            onFilterCriteriaChange={this.handleFilterCriteriaChange}
                            onFilterCriteriaReset={this.handleFilterCriteriaReset}
                            onFilterCriteriaExportCSV={() => this.handleExport(exportFileType.CSV)}
                            onTableChange = {this.handleTableChange}
                            onRefresh={this.handleRefresh}
                            accessToken={accessToken}
                            username={username}
                            isDownloading={downloading.value}
                        />
                    </Card.Body>
                </Card>
                <SimpleModal
                    modal={modal}
                    onClose={this.handleModalClose}
                />
                <LoadingModal show={loadingShow} />
            </React.Fragment>
        );
    }
}
export default OnlineRegistrationReport;